<template>
  <div
      :is="componentType"
      :video="video"
      :autoplay="autoplay"
      :show-reel-clips="showReelClips"
    />
</template>

<script>
import AwsPlayer from '@/components/VideoPlayers/AwsPlayer'
import HudlPlayer from '@/components/VideoPlayers/HudlPlayer'
import LegacyPlayer from '@/components/VideoPlayers/LegacyPlayer'
import ReelPlayer from '@/components/VideoPlayers/ReelPlayer'
import PublishedReelPlayer from '@/components/VideoPlayers/PublishedReelPlayer'
import VimeoPlayer from '@/components/VideoPlayers/VimeoPlayer'
import YouTubePlayer from '@/components/VideoPlayers/YouTubePlayer'
import KrossoverPlayer from './VideoPlayers/KrossoverPlayer'
import ConnectSportsPlayer from './VideoPlayers/ConnectSportsPlayer.vue'
import SrVideoPlayer from './VideoPlayers/SrVideoPlayer.vue'

export default {
  props: {
    video: { type: Object, required: true },
    autoplay: { type: Boolean, default: false },
    showReelClips: { type: Boolean, default: true },
  },

  computed: {
    videoHost() {
      return this.video.video_host
    },
    componentType() {
      return {
        aws: AwsPlayer,
        hudl: HudlPlayer,
        legacy: LegacyPlayer,
        reel: ReelPlayer,
        vimeo: VimeoPlayer,
        youtube: YouTubePlayer,
        krossover: KrossoverPlayer,
        connectsports: ConnectSportsPlayer,
        video_project_published_video: PublishedReelPlayer,
        video: SrVideoPlayer,
      }[this.videoHost]
    },
  },
}
</script>
